import unescapedText from 'I18n/utils/unescapedText';
import { SliderSection } from './SliderSection';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * "Popular workflow templates" carousel for the homepage. Renders a single
 * workflow-template suggestion section under a fixed title. Renders nothing
 * when there is no section or it has no cards.
 */
export function WorkflowTemplatesSection({
  section,
  sectionIndex
}) {
  var _section$contexts;
  if (!section || section.cards.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(SliderSection, {
    cards: section.cards,
    context: (_section$contexts = section.contexts) === null || _section$contexts === void 0 ? void 0 : _section$contexts[0],
    title: unescapedText('marketplaceStorefront.workflowTemplates.popularSectionTitle'),
    sectionIndex: sectionIndex,
    sectionType: section.sectionType
  });
}